<template lang="pug">
#pills-manual.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='pills-manual-tab')
  .package-table.border-0.pb-3.m-0
    template(v-if="getBankAcc.length > 0 && getBankAcc[0].bank_acc_holder != null && getBankAcc[0].bank_acc_no != null && getBankAcc[0].bank_name != null")
      .row.table-row
        .col-5.text-left Account Name
        .col-1.px-0 :
        .col-6.text-left {{getBankAcc[0].bank_acc_holder}} ({{getBankAcc[0].bank_name}})
      .row.table-row
        .col-5.text-left Account Number
        .col-1.px-0 :
        .col-6.text-left
          .text-success {{getBankAcc[0].bank_acc_no}}
    template(v-else)
      .row.table-row
        .col-5.text-left Account Name
        .col-1.px-0 :
        .col-6.text-left MMK555
      .row.table-row
        .col-5.text-left Account Number
        .col-1.px-0 :
        .col-6.text-left
          .text-success.text-decoration-none Please contact us for bank info
    .row.table-row
      .col-5.text-left Minimum Amount
      .col-1.px-0 :
      .col-6.text-left MMK 1
    template(v-if="getSocialAcc.length > 0")
      template(v-for="acc in getSocialAcc")
        .row.table-row(v-if="acc.contact_phone && acc.contact_phone != null && acc.contact_phone != ''")
          .col-5.text-left Contact (Phone):
          .col-1.px-0 :
          .col-6.text-left {{acc.contact_phone}}
        .row.table-row(v-if="!mobileDevice && acc.viber && acc.viber != null && acc.viber != ''")
          .col-5.text-left Contact (Viber):
          .col-1.px-0 :
          .col-6.text-left {{acc.viber}}
        .mt-3.d-flex.justify-content-center(v-if="getSocialAcc.length > 0")
          a.mr-2(v-if="acc.telegram && acc.telegram != null && acc.telegram != '' " :href="tgLink(acc.telegram)" target="_blank")
            img(src='img/social_media/social-telegram.png')
          a.mr-2(v-if="mobileDevice && acc.viber && acc.viber != null && acc.viber != '' " :href="vbLink(acc.viber)" target="_blank")
            img(src='img/social_media/social-viber.png')
          a.mr-2(v-if="acc.whatsapp && acc.whatsapp != null && acc.whatsapp != ''" :href="waLink(acc.whatsapp)" target="_blank")
            img(src='img/social_media/social-whatsapp.png')
  form
    template(v-if="getPromoList.length > 0")
      .input-group.mb-4
        .selected-promo.form-control(v-if="getPromoSelected==''" @click="showPromoList") Please select a promotion
        .selected-promo.form-control(v-else @click="showPromoList") {{getPromoDetail[0].promotion_name}} (Bonus - {{getPromoDetail[0].bonus_rate}} Rollover - {{getPromoDetail[0].rollover}})
        //- .selected-promo.form-control(v-if="getPromoSelected ===''" @click="showPromoList") Please select a promotion
        //- .selected-promo.form-control(v-else @click="showPromoList")
          div(v-if="promoDetails.length > 0") {{promoDetails[0].promotion_name}} (Bonus - {{promoDetails[0].bonus_rate}} Rollover - {{promoDetails[0].rollover}})
          div(v-else-if="promoSelected.length > 0") {{promoSelected.promotion_name}} (Bonus - {{promoSelected.bonus_rate}} Rollover - {{promoSelected.rollover}})
          div.text-center(v-else)
            i.fas.fa-sync.fa-spin
    .input-group.mb-4
      label.px-2.input-field {{$t('ui.amount')}}
      input.text-center.rounded-pill.form-control(type="number" v-model.trim="$v.depositAmount.$model")
      .text-error.w-100.text-center.text-danger(v-if="!$v.depositAmount.required && $v.depositAmount.$dirty") {{$t('ui.deposit_enter')}}
      .text-error.w-100.text-center.text-danger(v-if="!$v.depositAmount.minValue && $v.depositAmount.$dirty") {{$t('ui.amount_not_min')}}
    .input-group.mb-4.w-100
      label.px-2.input-field Upload File
      .custom-file
        input#inputGroupFile01.custom-file-input.pointer(type='file' aria-describedby='inputGroupFileAddon01' ref="file" @click="resetImage" @change="onSelect")
        label.custom-file-label.rounded-pill.pointer(for='inputGroupFile01') {{ imageName }}
      .text-center.w-100.text-error File size cannot exceed 1mb and must be in png, jpg or jpeg format
      .text-error.w-100.text-center.text-danger.mt-1(v-if="!$v.imageName.required && $v.imageName.$dirty") {{$t('ui.attachment_tips')}}
    .text-center.mb-2
      a.d-inline-block(href="javascript:void(0);" @click.stop="onSubmit")
        .text-center.btn.rounded-pill.text-uppercase.btn-main deposit now
</template>
<script>
import config from "@/config"
import { required, minValue } from "vuelidate/lib/validators"
export default {
  props:{
    minDeposit: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      file: "",
      imageName: "",
      message: "",
      feedback: {
        success: true,
        status: ""
      },
      filename: "",
      depositAmount: "",
      packageId:"",
      conditionChecked: false,
      promoDetails: [],
      mobileDevice: false
    }
  },
  validations() {
    return {
      depositAmount: {
        required,
        minValue: minValue(this.minDeposit)
      },
      imageName:{
        required
      },
      // conditionChecked:{
      //   required(val) {
      //     return val;
      //   }
      // }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getPromoList(){
      return this.$store.getters.promoList.data.PROMOTION_LIST
    },
    getBankAcc(){
      return this.$store.getters.promoList.data.BANK_ACC
    },
    getSocialAcc(){
      return this.$store.getters.promoList.data.SOCIAL_ACC
    },
    getPromoSelected(){
      if(this.$store.getters.promoSelected!=""){
        if(this.getPromoList.some(promo => promo.promotion_id === this.$store.getters.promoSelected)){
          return this.$store.getters.promoSelected
        }else{
          return ""
        }
      }else{
        return this.$store.getters.promoSelected
      }   
		},
    getPromoDetail(){
      return this.$store.getters.promoDetail
    },
    getMindeposit(){
      if(this.minDeposit != 0){
        return this.minDeposit
      }else{
        return ""
      }
    }
  },
  watch:{
    minDeposit:{
      immediate: true, 
      handler (val, oldVal) {
        if(val != 0){
          if(val != this.depositAmount){
            this.depositAmount = val
          }
        }
      }
    },
  },
  // updated(){
  //   console.log(this.getPromoSelected)
  // },
  mounted(){
    this.getMobile()
    var vm = this;
    $("#modal-deposit").on("shown.bs.modal", function() {
      if(vm.getPromoSelected!=""){
        if(vm.getPromoList.some(promo => promo.promotion_id === vm.getPromoSelected)){
          vm.depositAmount = vm.getPromoDetail[0].min_deposit
        }
      } 
    })  
    $("#modal-deposit").on("hidden.bs.modal", function() {
      vm.reset()
    })
  },
  methods:{
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
      // let isMobile = {
      //   Android: function () {
      //     return navigator.userAgent.match(/Android/i);
      //   },
      //   BlackBerry: function () {
      //     return navigator.userAgent.match(/BlackBerry/i);
      //   },
      //   iOS: function () {
      //     return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      //   },
      //   Opera: function () {
      //     return navigator.userAgent.match(/Opera Mini/i);
      //   },
      //   Windows: function () {
      //     return navigator.userAgent.match(/IEMobile/i);
      //   },
      //   any: function () {
      //     return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
      //   }
      // }

      // if (isMobile.Android() || isMobile.iOS()) {
      //   this.mobileDevice = true
      // } else {
      //   this.mobileDevice = false
      // }
    },
    waLink(acc){
      return "https://wa.me/" + acc
    },
    tgLink(acc){
      return "https://t.me/" + acc
    },
    vbLink(acc){
      return "viber://chat/?number=%2B" + acc
    },
    showPromoList(){
      this.$emit('showPromoList', {
        target : 'MANUAL'
      });
    },
    onSelect() {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if(this.$refs.file.files.length > 0){
        var file = this.$refs.file.files[0];
        this.imageName = this.$refs.file.files[0].name;
        this.file = file;
      }else{
        return
      }

      if (!allowedTypes.includes(file.type)) {
        this.message = this.$t("message.wrong_filetype");
      }
      if (file.size > 1000000) {
        this.message = "Too large, max size allowed is 1mb";
      }
    },
    resetImage(){
      this.$refs.file.value = '';
    },
    async onSubmit() {
      if (this.imageName === "") {
        this.manualDeposit();
      } else {
        const formData = new FormData();
        formData.append("file", this.file);
        this.loading = true;
        try {
          await this.$http
            .post("https://upload.uploadattachmentmmk5.com/upload", formData)
            .then(function(response) {
              if (response.data.file.filename) {
                this.filename = response.data.file.filename;
              }
              this.manualDeposit();
            });
          this.message = "Uploaded!!";
        } catch (err) {
          if(err.status === 0 && err.data === ""){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
          }else{
            this.message = err.data.error;
            this.loading = false;
            this.$helpers.showDialog(this.$t("ui.attention"), this.message , "info", this)
          }
        }
      }
    },
    manualDeposit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {

          let member_id = this.accountID
          let auth_token = this.sessionToken
          let amount = this.depositAmount
          let attachment_path = this.filename != "" ? "https://img.uploadattachmentmmk5.com/" + this.filename : ""
          if(this.getPromoSelected == ""){
            var promotion_id = null
          }else{
            var promotion_id = this.getPromoSelected
          }
          this.loading = true
          this.$store
            .dispatch("user/manualDeposit", { member_id, amount, attachment_path, promotion_id, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                $("#modal-deposit").modal("hide")
                this.$router.push({ name: '/statement', params: {target: "pills-transaction-tab"} }).catch(err => {
                  this.$router.replace({ name: "refresh", params: {target: "pills-transaction-tab"} });
                });
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              var vm = this;
              this.loading = false
              this.feedback.success = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              }
              this.feedback.status = this.$t("error." + response.status)
            });
        }
      }
    },
    reset() {
      this.$store.dispatch("user/setPromoSelected", "")
      this.file = ""
      this.message = ""
      this.filename = ""
      this.imageName = ""
      this.depositAmount = ""
      this.packageId = ""
      this.feedback.success = true
      this.feedback.status = ""
      this.conditionChecked = false
      this.$v.$reset()
    },
  }
}
</script>
<style lang="scss" scoped>
label{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>